//ionic
import { IonGrid, IonText, IonButton } from '@ionic/react';

//css
import './progress-component.css';
import { useGetProgressHistory } from 'hooks/progress/useGetProgressHistory';
import { useEffect, useState } from 'react';
import { useGetTrainingHistory } from 'hooks/progress/useGetTrainingHistory';

export const HistorialEntrenamiento: React.FC = () => {

  const { handleGettrainingHistory, trainingHistory } = useGetTrainingHistory()
  const [limit, setLimit] = useState(1)


  useEffect(() => {
    handleGettrainingHistory(limit)
  }, [limit])

  return (
    <IonGrid className="p-historial-container">
      <IonText className="p-historial-title">Historial</IonText>
    {trainingHistory.length !== 0 && 
      trainingHistory.map( (progress:any) => { 

        return(
          <>
            <div className="p-historial-div">
              <IonText className="p-historial-day">{progress.name}</IonText>
            </div>
            {
              progress.data.map( (element:any) =>{
                return(
                  <div className="flex" style={{ alignItems: 'center', marginTop: '16px' }}>
                    <div className="p-circle" style={{ background: '#FFE1D4' }}></div>
                    <div className="flex" style={{ flexDirection: 'column' }}>
                      <IonText className="p-historial-exercise">{element.nameModule}</IonText>
                      <IonText className="p-historial-description">Entrenamiento Rápido de {element.minutes} minutos</IonText>
                    </div>
                  </div>
                )
              })
            }
          </>
        )
      })
    }

      <IonButton onClick={()=> setLimit(prevState => prevState + 1)} className="ls-button" fill="clear">
        Ver más Historial
      </IonButton>
    </IonGrid>
  );
};
